import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/data/store";

import type { BrowserStorageNotice } from "./notice";

export interface BrowserStorageSliceState {
  /** The active offline-backup notice (see {@link BrowserStorageNotice}). */
  notice: BrowserStorageNotice;
}

export const initialState: BrowserStorageSliceState = {
  notice: "none",
};

export const browserStorageSlice = createSlice({
  name: "browserStorage",
  initialState,
  reducers: {
    setBrowserStorageNotice(
      state,
      action: PayloadAction<BrowserStorageNotice>
    ) {
      state.notice = action.payload;
    },
  },
});

export const { setBrowserStorageNotice } = browserStorageSlice.actions;

export const browserStorageReducer = browserStorageSlice.reducer;

/** The active offline-backup notice, or `"none"`. */
export const selectBrowserStorageNotice = (state: RootState) =>
  state.browserStorage.notice;
